export default "__VITE_ASSET__paTVjUbT__"